import type { DiagnosticLauncherGestureProps } from './diagnostic-launcher-gesture.types';

export const DiagnosticLauncherGesture = ({ children }: DiagnosticLauncherGestureProps) => children;
